import { inject } from '@angular/core'
import { ResolveFn } from '@angular/router'

import { QuarterlyDashboardFacade } from '~/core/features'

export const quarterlyDashboardQuarterDataResolver: ResolveFn<void> = () => {
  return inject(QuarterlyDashboardFacade).getQuarterlyDashboardQuarterData()
}
